import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { InlineWidget } from "react-calendly";
import { ArrowLeft, Check, CreditCard } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import Cal, { getCalApi } from "@calcom/embed-react";
import { fallbackServices } from "@/data/services";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.elysana-massage.de";
const API = `${BACKEND_URL}/api`;

// Cal.com React component for 90 min service (Ganzkörpermassage)
const CalComWidget90Min = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"jetzt-buchen"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Ganzkörpermassage (90 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="jetzt-buchen"
        calLink="elysana-massage/jetzt-buchen"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-90min"
      />
    </div>
  );
};

// Cal.com React component for 45 min Hot Stone Massage
const CalComWidget45Min = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"45-min-book-now"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Hot Stone Massage (45 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="45-min-book-now"
        calLink="elysana-massage/45-min-book-now"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-45min"
      />
    </div>
  );
};

// Cal.com React component for 30 min Aroma Öl Massage
const CalComWidget30Min = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"30min"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Aroma Öl Massage (30 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="30min"
        calLink="elysana-massage/30min"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-30min"
      />
    </div>
  );
};

// Cal.com React component for 60 min Abhyanga / Ayurveda Ganzkörpermassage
const CalComWidget60MinAbhyanga = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"60min"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Abhyanga / Ayurveda Ganzkörpermassage (60 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="60min"
        calLink="elysana-massage/60min"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-60min-abhyanga"
      />
    </div>
  );
};

// Cal.com React component for 60 min Thai Massage
const CalComWidget60MinThai = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"jetzt-buchen-60min"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Thai Massage (60 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="jetzt-buchen-60min"
        calLink="elysana-massage/jetzt-buchen-60min"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-60min-thai"
      />
    </div>
  );
};

// Cal.com React component for 45 min Sanjeevani Massage
const CalComWidget45MinSanjeevani = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"jetzt-buchen45min"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Sanjeevani Massage (45 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="jetzt-buchen45min"
        calLink="elysana-massage/jetzt-buchen45min"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-45min-sanjeevani"
      />
    </div>
  );
};

// Cal.com React component for 45 min Mukabhyanga Massage
const CalComWidget45MinMukabhyanga = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"jetzt-buchen-mukabhyanga-massage"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Mukabhyanga Massage (45 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="jetzt-buchen-mukabhyanga-massage"
        calLink="elysana-massage/jetzt-buchen-mukabhyanga-massage"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-45min-mukabhyanga"
      />
    </div>
  );
};

// Cal.com React component for 45 min Bein und Fuß Massage
const CalComWidget45MinLegFoot = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"jetz-buchenbein-und-fuß-massage-mit-peeling"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Bein und Fuß Massage (45 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="jetz-buchenbein-und-fuß-massage-mit-peeling"
        calLink="elysana-massage/jetz-buchenbein-und-fuß-massage-mit-peeling"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-45min-legfoot"
      />
    </div>
  );
};

// Cal.com React component for 45 min Rückenmassage
const CalComWidget45MinBack = () => {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"jetz-buchen-ruckenmassage"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
      } catch (error) {
        console.error('Cal.com API error:', error);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-secondary/20 bg-white/50 backdrop-blur-sm p-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-primary">Rückenmassage (45 min)</h3>
        <p className="text-sm text-text-muted">Wählen Sie Ihren bevorzugten Termin</p>
      </div>
      <Cal 
        namespace="jetz-buchen-ruckenmassage"
        calLink="elysana-massage/jetz-buchen-ruckenmassage"
        style={{
          width:"100%",
          height:"700px",
          overflow:"scroll"
        }}
        config={{
          "layout":"month_view"
        }}
        data-testid="calcom-react-widget-45min-back"
      />
    </div>
  );
};

const BookingFlow = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [service, setService] = useState(
    fallbackServices.find((s) => s.id === serviceId) || null
  );
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get Calendly URL based on service duration
  const getCalendlyUrl = (duration) => {
    switch (duration) {
      case "30 min":
        return "https://calendly.com/joshyusifov/30min";
      case "45 min":
        return "https://calendly.com/joshyusifov/new-meeting";
      case "60 min":
        return "https://calendly.com/joshyusifov/book-now-1-hour";
      case "90 min":
        return null; // Will use Cal.com instead
      default:
        return "https://calendly.com/joshyusifov/new-meeting"; // Default to 45 min
    }
  };

  // Check if service uses Cal.com (now ALL services use Cal.com)
  const usesCalCom = (serviceId) => {
    return ["full-body", "hot-stone", "aroma-oil", "abhyanga", "thai", "sanjeevani", "mukabhyanga", "leg-foot", "back"].includes(serviceId);
  };

  useEffect(() => {
    fetchService();
  }, [serviceId]);

  const fetchService = async () => {
    // First try to get from fallback (instant)
    const fallbackService = fallbackServices.find((s) => s.id === serviceId);
    if (fallbackService) {
      setService(fallbackService);
    }

    // Then try to fetch from API
    try {
      const response = await axios.get(`${API}/services`, {
        timeout: 5000,
      });
      
      if (Array.isArray(response.data) && response.data.length > 0) {
        const selectedService = response.data.find((s) => s.id === serviceId);
        if (selectedService) {
          setService(selectedService);
          return;
        }
      }
    } catch (error) {
      console.error("Error fetching service from API:", error);
      // Continue with fallback service if API fails
    }

    // If API didn't return the service, use fallback
    if (!fallbackService) {
      toast.error("Leistung nicht gefunden");
      navigate("/");
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleContactFormSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.fullName || !formData.email || !formData.phone) {
      toast.error("Bitte f\u00fcllen Sie alle Felder aus");
      return;
    }

    if (!service) {
      toast.error("Leistung nicht gefunden");
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Try to save booking to backend
      await axios.post(
        `${API}/bookings`,
        {
          full_name: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          service_name: service.title,
          service_price: service.price,
        },
        {
          timeout: 10000,
        }
      );
      
      toast.success("Kontaktinformationen gespeichert!");
      setCurrentStep(2);
    } catch (error) {
      console.error("Error saving booking:", error);
      // Even if backend fails, continue to next step (offline-friendly)
      toast.success("Kontaktinformationen gespeichert!");
      setCurrentStep(2);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCalendlyScheduled = () => {
    toast.success("Termin erfolgreich gebucht! Wir freuen uns auf Sie.");
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  const handleCalComScheduled = () => {
    toast.success("Termin erfolgreich gebucht! Wir freuen uns auf Sie.");
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  // Add event listener for Cal.com bookings
  useEffect(() => {
    if (currentStep === 2 && service && usesCalCom(service.id)) {
      const handleCalComEvent = (e) => {
        if (e.detail && e.detail.type === 'bookingSuccessful') {
          handleCalComScheduled();
        }
      };

      window.addEventListener('cal:bookingSuccessful', handleCalComEvent);
      
      return () => {
        window.removeEventListener('cal:bookingSuccessful', handleCalComEvent);
      };
    }
  }, [currentStep, service]);

  if (!service) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-text-secondary">Wird geladen...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background grain-texture py-12 px-6">
      <div className="max-w-3xl mx-auto">
        {/* Back Button */}
        <motion.button
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          onClick={() => currentStep === 1 ? navigate("/") : setCurrentStep(currentStep - 1)}
          className="flex items-center gap-2 text-primary hover:text-accent transition-colors mb-8"
          data-testid="back-button"
        >
          <ArrowLeft size={20} />
          <span>{currentStep === 1 ? "Zur\u00fcck zu den Leistungen" : "Vorheriger Schritt"}</span>
        </motion.button>

        {/* Progress Steps */}
        <div className="flex items-center justify-center gap-4 mb-12">
          {[1, 2].map((step) => (
            <div key={step} className="flex items-center gap-2">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all ${
                  currentStep >= step
                    ? "bg-primary text-primary-foreground"
                    : "bg-secondary/30 text-text-muted"
                }`}
                data-testid={`step-indicator-${step}`}
              >
                {currentStep > step ? <Check size={20} /> : step}
              </div>
              {step < 2 && (
                <div
                  className={`w-16 h-1 rounded-full transition-all ${
                    currentStep > step ? "bg-primary" : "bg-secondary/30"
                  }`}
                />
              )}
            </div>
          ))}
        </div>

        {/* Step Labels */}
        <div className="flex items-center justify-center gap-8 mb-12 text-sm">
          <span className={currentStep >= 1 ? "text-primary font-medium" : "text-text-muted"}>Kontaktinfo</span>
          <span className={currentStep >= 2 ? "text-primary font-medium" : "text-text-muted"}>Terminplanung</span>
        </div>

        {/* Service Summary */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white/50 backdrop-blur-sm rounded-xl p-6 border border-white/20 mb-8"
        >
          <h3 className="text-2xl font-bold text-primary mb-2">{service.title}</h3>
          <div className="flex items-center justify-between">
            <p className="text-text-secondary">{service.description}</p>
            <div className="text-right ml-4">
              <div className="flex items-center gap-2 justify-end mb-1">
                {service.originalPrice && (
                  <p className="text-base text-text-muted line-through">{service.originalPrice}</p>
                )}
                <p className="text-2xl font-bold text-accent">{service.price}</p>
              </div>
              <p className="text-sm text-text-muted">{service.duration}</p>
            </div>
          </div>
        </motion.div>

        <AnimatePresence mode="wait">
          {/* Step 1: Contact Information */}
          {currentStep === 1 && (
            <motion.div
              key="step1"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              className="bg-white/50 backdrop-blur-sm rounded-xl p-8 border border-white/20"
            >
              <h2 className="text-3xl font-bold text-primary mb-6">Ihre Kontaktinformationen</h2>
              <p className="text-text-secondary mb-8">Bitte geben Sie Ihre Daten an, um mit der Buchung fortzufahren</p>
              
              <form onSubmit={handleContactFormSubmit} className="space-y-6">
                <div>
                  <Label htmlFor="fullName" className="text-primary mb-2 block">Name *</Label>
                  <Input
                    id="fullName"
                    name="fullName"
                    type="text"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="Max Mustermann"
                    required
                    data-testid="input-fullname"
                    className="bg-white/50 border-primary/20 focus:border-primary rounded-md"
                  />
                </div>

                <div>
                  <Label htmlFor="email" className="text-primary mb-2 block">E-Mail-Adresse *</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="max@beispiel.de"
                    required
                    data-testid="input-email"
                    className="bg-white/50 border-primary/20 focus:border-primary rounded-md"
                  />
                </div>

                <div>
                  <Label htmlFor="phone" className="text-primary mb-2 block">Telefonnummer *</Label>
                  <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="+49 123 456 7890"
                    required
                    data-testid="input-phone"
                    className="bg-white/50 border-primary/20 focus:border-primary rounded-md"
                  />
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  disabled={isSubmitting}
                  className="btn-primary w-full"
                  data-testid="submit-contact-form-btn"
                >
                  {isSubmitting ? "Wird gespeichert..." : "Weiter zur Terminplanung"}
                </motion.button>
              </form>
            </motion.div>
          )}

          {/* Step 2: Calendly Scheduling */}
          {currentStep === 2 && (
            <motion.div
              key="step2"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              className="bg-white/50 backdrop-blur-sm rounded-xl p-8 border border-white/20"
            >
              <h2 className="text-3xl font-bold text-primary mb-6">Planen Sie Ihren Termin</h2>
              <p className="text-text-secondary mb-8">Wählen Sie Ihr bevorzugtes Datum und Ihre Uhrzeit</p>
              
              {/* Booking Widget - Cal.com for all services */}
              {usesCalCom(service.id) ? (
                /* Cal.com Widget - Different widget based on service */
                service.id === "full-body" ? (
                  <CalComWidget90Min />
                ) : service.id === "hot-stone" ? (
                  <CalComWidget45Min />
                ) : service.id === "aroma-oil" ? (
                  <CalComWidget30Min />
                ) : service.id === "abhyanga" ? (
                  <CalComWidget60MinAbhyanga />
                ) : service.id === "thai" ? (
                  <CalComWidget60MinThai />
                ) : service.id === "sanjeevani" ? (
                  <CalComWidget45MinSanjeevani />
                ) : service.id === "mukabhyanga" ? (
                  <CalComWidget45MinMukabhyanga />
                ) : service.id === "leg-foot" ? (
                  <CalComWidget45MinLegFoot />
                ) : service.id === "back" ? (
                  <CalComWidget45MinBack />
                ) : null
              ) : (
                /* Calendly Widget for other services (not used anymore) */
                <div className="rounded-xl overflow-hidden">
                  <InlineWidget
                    url={getCalendlyUrl(service.duration)}
                    styles={{ 
                      height: '700px', 
                      minWidth: '320px',
                      borderRadius: '12px'
                    }}
                    prefill={{
                      name: formData.fullName,
                      email: formData.email,
                      customAnswers: { a1: formData.phone }
                    }}
                    onScheduled={handleCalendlyScheduled}
                    data-testid="calendly-widget"
                  />
                </div>
              )}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default BookingFlow;